
<div class="main-content">
  <div class="container-fluid">
    <!--<button (click)="getFiles(this.idFolder)" mat-raised-button class="btn btn-success">-->
    <!-- <button (click)="doRefresh()" mat-raised-button class="btn btn-success">
      <span class="btn-label">
        <i class="material-icons">refresh</i>
      </span>
      Refresh
    </button> -->

    <!-- <div
      *ngIf="
        this.privilegio.level == 'ADMINISTRATOR' ||
        this.privilegio.level == 'worker' ||
        this.privilegio.level == 'PURCHASINGREP' ||
        this.privilegio.level == 'MANAGER'
      "
      style="float: right; margin-right: 20px"
      class="row"
    >
      <button
        (click)="openNuevoFolder()"
        mat-raised-button
        class="btn btn-success"
      >
        <span class="btn-label">
          <i class="material-icons">create_new_folder</i>
        </span>
        New Folder
      </button>
    </div> -->


    <!-- <button (click)="upFolder()" mat-raised-button class="btn btn-success">
      <span class="btn-label">
        <i class="material-icons">publish</i>
      </span>
      Back
    </button> -->

    <!-- <button
      *ngIf="this.fullPermission == 1"
      (click)="downloadAll()"
      mat-raised-button
      class="btn btn-success"
    >
      <span class="btn-label">
        <i class="material-icons">cloud_download</i>
      </span>
      Download All
    </button> -->

    <!-- <button
      *ngIf="this.fullPermission == 1 && poID != null && this.identity.role != 'VENDOR' && this.identity.role != 'customer'"
      mat-raised-button
      class="btn btn-success"
      routerLink="/processing-instructions/{{ poID }}"
    >
      <span class="btn-label">
        <i class="material-icons">description</i>
      </span>
      Go processing
    </button> -->

    <div class="row">
      <div class="col-md-12">
        <div class="card">

          <div class="card-header card-header-primary card-header-icon">
<!--             <div class="card-icon">
              <i class="material-icons">folder</i>
            </div> margin: 16px 8px 0px 78px-->
            <nav class="itad-breadcrumb" style="margin-left: 7px; margin-top: 20px;">
              <a [routerLink]="['/tables/listfiles']" *ngIf="this.identity.role != 'VENDOR' && this.identity.role != 'customer'">Home/</a>
              <span *ngFor="let crumb of breadcrumbs; let last = last">
                <a [routerLink]="['/tables/listfiles/', crumb.url]" [class.last]="last">{{ crumb.label }}</a>
                <span style="font-size: 25px; font-weight: 400; color: black;" *ngIf="!last">/</span>
              </span>
            </nav>
          </div>

          <div class="card-body"> <!-- START CONTENT-->
            
            <section class="toolbar-container">

              <div class="toolbar-button-container">
                <app-button-select 
                  [options]="optionsButtonSelect" 
                  [(selected)]="optionSelectMenuTrigger"
                  (selectedChange)="menuTriggerToShow($event)"
                  [label]="'Type'"
                  [disabled]="archivedFolders"
                  >
                </app-button-select>

                <section class="container-buttons-right">
                  <mat-slide-toggle [(ngModel)]="archivedFolders" (change)="onToggleChange($event)" class="toggle" *ngIf="breadcrumbs.length === 1">View Archived Folders</mat-slide-toggle>
                </section>

              </div>

              <div class="toolbar-button-container">
                <button [disabled]="archivedFolders" *ngIf=" this.privilegio.level == 'ADMINISTRATOR' || this.privilegio.level == 'MANAGER' || this.privilegio.level == 'worker' || this.privilegio.level == 'PURCHASINGREP'"
                         class="gts-btn-primary-outline" matRipple (click)="showModalPermissions()">
                  <span class="gts-btn-icon-left">lock_open</span><span class="gts-btn-text">Permissions for all folders</span>
                </button>
                <button [disabled]="archivedFolders" class="gts-btn-primary-outline" matRipple (click)="showModalAdvancedSearch()" *ngIf="optionSelectMenuTrigger !== 'archived folders' && breadcrumbs.length === 1">
                  <span class="gts-btn-icon-left">find_in_page</span><span class="gts-btn-text">advanced search</span>
                </button>
                <button [disabled]="archivedFolders"  (click)="showModalAddFiles()" class="gts-btn-primary-outline" matRipple *ngIf=" this.privilegio.level == 'ADMINISTRATOR' || this.privilegio.level == 'MANAGER' || this.privilegio.level == 'worker' || this.privilegio.level == 'CLERICALREP' || this.privilegio.level == 'PURCHASINGREP'">
                  <span class="gts-btn-icon-left">upload_file</span><span class="gts-btn-text">Upload Files</span>
                </button>
                <button (click)="downloadZip(1)" *ngIf="this.fullPermission == 1 && optionSelectMenuTrigger === 'foldersFiles' && breadcrumbs.length > 1" class="gts-btn-primary-outline" [disabled]="downloadingState[1] || (data.rows.length < 1 && dataFiles?.rows.length < 1)">
                  <i class="fa fa-circle-o-notch fa-spin fa-1x fa-fw" *ngIf="downloadingState[1]"></i>
                  <span class="gts-btn-icon-left" *ngIf="!downloadingState[1]">file_download</span>
                  <span class="gts-btn-text">Download All</span>
                </button>
                <button (click)="downloadZip(0)" *ngIf="this.fullPermission == 1 && optionSelectMenuTrigger === 'folders' && breadcrumbs.length > 1" class="gts-btn-primary-outline" [disabled]="downloadingState[0] || data.rows.length < 1">
                  <i class="fa fa-circle-o-notch fa-spin fa-1x fa-fw" *ngIf="downloadingState[0]"></i>
                  <span class="gts-btn-icon-left" *ngIf="!downloadingState[0]">file_download</span>
                  <span class="gts-btn-text">Download Folders</span>
                </button>
                <button (click)="downloadZip(2)" *ngIf="this.fullPermission == 1 && optionSelectMenuTrigger === 'files' && breadcrumbs.length > 1" class="gts-btn-primary-outline" [disabled]="downloadingState[2] || dataFiles?.rows.length < 1">
                  <i class="fa fa-circle-o-notch fa-spin fa-1x fa-fw" *ngIf="downloadingState[2]"></i>
                  <span class="gts-btn-icon-left" *ngIf="!downloadingState[2]">file_download</span>
                  <span class="gts-btn-text">Download Files</span>
                </button>
                
                <button [disabled]="archivedFolders" class="gts-btn-primary" matRipple (click)="openNuevoFolder()" *ngIf="
                        this.privilegio.level == 'ADMINISTRATOR' ||
                        this.privilegio.level == 'worker' ||
                        this.privilegio.level == 'PURCHASINGREP' ||
                        this.privilegio.level == 'MANAGER'">
                  <span class="gts-btn-icon-left">create_new_folder</span><span class="gts-btn-text">New Folder</span>
                </button>
              </div>

            </section>
            <div *ngIf="noPaymentFromClientAlert" class="alert alert-danger">
              Your files are not yet available. Please contact your account representative.
            </div>
 <!-- **********************************************TABLE FOLDER  ********************************************** -->
            <section>
              <h3 style="font-family: 'Roboto'; font-weight: 500; font-size: 20px; color: #8c8c8c; margin: 0px 0px 8px 0px" *ngIf="(optionSelectMenuTrigger === 'folders' || optionSelectMenuTrigger === 'foldersFiles') && !archivedFolders">Folders</h3>

              <div style="position: relative;" *ngIf="!(loading || loadingDataFolders)">
                <!-- BTN FLOAT -->
                <section [ngClass]="getClass()" *ngIf="bulk.length > 0 && (optionSelectMenuTrigger === 'folders' || optionSelectMenuTrigger === 'foldersFiles') && breadcrumbs.length === 1">
                    <div style="display: flex">
  
                        <div class="title-actions">
                          <b class="gts-btn-text">{{ bulk.length }} Selected: </b>
                        </div>
                        <button class="gts-btn-primary-outline-actions-end" matRipple       
                          (click)="archiveBulk()" matTooltip="Archive">
                          <span class="gts-btn-icon" >archive</span>
                        </button>
  
                    </div>
                </section>
              </div>

              <mat-progress-bar style="width: 100%; margin: 16px 0px" *ngIf="(loading || loadingDataFolders) && (optionSelectMenuTrigger === 'folders' || optionSelectMenuTrigger === 'foldersFiles')" id="loadingbar" mode="indeterminate"></mat-progress-bar>

              <section *ngIf="(optionSelectMenuTrigger === 'folders' || optionSelectMenuTrigger === 'foldersFiles') && !archivedFolders">
                
                <!-- <div style="text-align: center; margin-top: 16px;" *ngIf="data.rows.length === 0 && !loadingDataFolders">
                  <img src="/assets/img/noFolders.svg" alt="noFolders" height="160px">
                </div> -->
                <!-- *ngIf="data?.rows.length > 0" -->
                <div [ngClass]="getClassConta()" *ngIf="!loadingDataFolders">
                  
                  <dinamic-table
                    [id]="'foldersTable_interna'" 
                    [data]="data"
                    [columnfilters]="filtros"
                    [campoBusqueda]="campoBusqueda"
                    [dateColums]="[4]" 
                    [perPage]="itemsPorPagina"
                    [page]="paginaActual"
                    [total_items_count]="totalItems"
                    [total_pages]="totalPaginas"
                    (buscar)="segundogetSubFolders($event,false, true)"
                    [bulk]="bulk" 
                    [enableDrop]=true 
                    (action_button)="action($event)"
                    (toggleButtons)="onToggleButtons($event)"
                    (idfolderdrop)="receivedFolderDrop($event)"
                    (rightClickAction)="handleRightClick($event)" 
                    >
                  </dinamic-table>
                </div>
               
              </section>

            </section>

    <!-- ********************************************** TABLE FILES ********************************************** -->
            <section>
              <div style="border-top: 1px solid #D9D9D9; margin: 12px 0px 8px 0px" *ngIf="optionSelectMenuTrigger === 'foldersFiles'">
              </div>
              <h3 style="font-family: 'Roboto'; font-weight: 500; font-size: 20px; color: #8c8c8c; margin: 0px 0px 8px 0px" *ngIf="(optionSelectMenuTrigger === 'files' || optionSelectMenuTrigger === 'foldersFiles') && !archivedFolders">Files</h3>

              <!-- BTN FLOAT -->
              <div style="position: relative;" *ngIf="!loadingDataFiles">
                
                <section style="position: absolute; top: 4px; left: 0; right: 0; z-index: 10; width: fit-content;" *ngIf="bulkFiles.length > 0">
                  <div style="display: flex">
                
                    <div class="title-actions">
                      <b class="gts-btn-text">{{ bulkFiles.length }} Selected: </b>
                    </div>
                    <button class="gts-btn-primary-outline-actions-end" matRipple (click)="downloadFilesZip()" matTooltip="Download {{bulkFiles.length === 1? 'File' : 'Files'}}">
                      <span class="gts-btn-icon">download</span>
                    </button>
                
                  </div>
                </section>
              </div>

              

              <mat-progress-bar style="width: 100%; margin: 16px 0px" *ngIf="(loadingDataFiles) && (optionSelectMenuTrigger === 'files' || optionSelectMenuTrigger === 'foldersFiles')" id="loadingbar" mode="indeterminate"></mat-progress-bar>

              <section *ngIf="(optionSelectMenuTrigger === 'files' || optionSelectMenuTrigger === 'foldersFiles') && !archivedFolders">
                
                <!-- <div style="text-align: center; margin-top: 16px;" *ngIf="dataFiles?.rows.length == 0 && !loadingDataFiles">
                  <img src="/assets/img/noFiles.svg" alt="noFiles" height="160px">
                </div> -->

                <!-- && this.contarFiles != 0 -->
                <div *ngIf="this.fullPermission == 1  && !loadingDataFiles" class="material-datatables">
                  <dinamic-table 
                  *ngIf="!loadingDataFiles" 
                  [id]="'filesTable'" 
                  [data]="dataFiles" 
                  [columnfilters]="filtrosFiles"
                  [campoBusqueda]="campoBusquedaFiles"
                  [perPage]="itemsPorPaginaFiles"
                  [page]="paginaActualFiles"
                  [total_items_count]="totalItemsFiles"
                  [total_pages]="totalPaginasFiles"
                  (buscar)="getFilesFolder($event,false)"
                  [bulk]="bulkFiles" 
                  (action_button)="actionFiles($event)"
                  (rightClickAction)="handleRightClickfile($event)" 
                  >
                  
                </dinamic-table>
                </div>
              </section>
            </section>

  <!--  ********************************************** TABLE ARCHIVED FOLDER ********************************************** -->
            <section>

              <h3 style="font-family: 'Roboto'; font-weight: 500; font-size: 20px; color: #8c8c8c; margin: 0px 0px 8px 0px" *ngIf="archivedFolders">Archived Folders</h3>

              <!-- BTN FLOAT -->
              <div style="position: relative;" *ngIf="!loadingDataArchivedFolders">
                
                <section style="position: absolute; top: 4px; left: 0; right: 0; z-index: 10; width: fit-content;" *ngIf="bulkArchivedFolders.length > 0 && archivedFolders && breadcrumbs.length === 1">
                  <div style="display: flex">
                
                    <div class="title-actions">
                      <b class="gts-btn-text">{{ bulkArchivedFolders.length }} Selected: </b>
                    </div>
                    <button class="gts-btn-primary-outline-actions-end" matRipple (click)="unarchive()" matTooltip="Unarchive">
                      <span class="gts-btn-icon">unarchive</span>
                    </button>
                
                  </div>
                </section>
              </div>

              <div *ngIf="archivedFolders">
                <mat-progress-bar style="width: 100%; margin: 16px 0px" *ngIf="loadingDataArchivedFolders" id="loadingbar" mode="indeterminate"></mat-progress-bar>
                <!-- <div style="text-align: center; margin-top: 16px;" *ngIf="dataArchivedFolders.rows.length === 0 && !loadingDataArchivedFolders">
                  <img src="/assets/img/noArchivedFolders.svg" alt="noFolders" height="160px">
                </div> -->
                <section>
                  <!-- && dataArchivedFolders.rows.length > 0 -->
                  <dinamic-table 
                    *ngIf="!loadingDataArchivedFolders" 
                    [id]="'archiveTable'" 
                    [data]="dataArchivedFolders" 
                    [columnfilters]="filtrosArchived"
                    [campoBusqueda]="campoBusquedaArchived"
                    [dateColums]="[4]"
                    [perPage]="itemsPorPaginaArchived"
                    [page]="paginaActualArchived"
                    [total_items_count]="totalItemsArchived"
                    [total_pages]="totalPaginasArchived"
                    (buscar)="getArchivedFolders($event,false)"
                    [bulk]="bulkArchivedFolders" 
                    (action_button)="actionArchiveFolders($event)">
                  </dinamic-table>
                </section>
              </div>
            </section>
          
        </div>
      </div>
    </div>
  </div>
</div>



<!-- ----------------------------------------------- MODALS -----------------------------------------------  -->


<!-- MODAL - modalAdvancedSearch -->
<div class="modal fade" id="modalAdvancedSearch" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false" (wheel)="onScroll($event)"><!-- MODAL - HB MODE OK -->
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Advanced Search</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      
      <div class="modal-body">    
        
        <!-- Form -->
        <section>

          <div style="padding-bottom: 16px">
            <mat-form-field appearance="fill">
              <mat-label>Search text inside the files</mat-label>
              <input matInput type="text" placeholder="Example: 'Greentek'" name="advancedsearchtext" [(ngModel)]="this.advancedsearchtext">
            </mat-form-field>

            <!-- <input type="text" placeholder="Search text inside the files" class="form-control"
            [(ngModel)]="this.advancedsearchtext" name="advancedsearchtext"/> -->
          </div>
          

          <div style="padding-bottom: 16px">
            <p class="itad-card-title-2">Where do you want to search?</p>
            <mat-radio-group [(ngModel)]="selectedSearchType" name="typesearch">
              <mat-radio-button value="1">Everywhere</mat-radio-button>
              <mat-radio-button value="2">Folders</mat-radio-button>
              <mat-radio-button value="3">Archived Folders</mat-radio-button>
            </mat-radio-group>
          </div>

          <div style="padding-bottom: 16px">
            <p class="itad-card-title-2">How do you want to receive the results?</p>
            <mat-radio-group [(ngModel)]="receiveresultsadvancedsearch" name="typeofresults">
              <mat-radio-button value="4">Instant Results</mat-radio-button>
              <mat-radio-button value="5">Email Results</mat-radio-button>
            </mat-radio-group>
          </div>

          <div style="padding-bottom: 16px">
            <p class="itad-card-title-2">Date Range</p>
            <mat-radio-group [(ngModel)]="daterangeadvancedsearch" name="ecttw">
              <mat-radio-button value="All">All</mat-radio-button>
              <mat-radio-button value="1">Select Range</mat-radio-button>
            </mat-radio-group>
          </div>

          <div style="padding-bottom: 16px" *ngIf="daterangeadvancedsearch == '1'" >
            <p class="itad-card-title-2">Date Range</p>
            <div style=" display: inline-flex;">
              <div style="margin-right: 40px;" class="form-group">
                <label for="bmd-label-floating">Initial Date:</label>
                <input type="date" class="form-control" name="initialDate" #initialDate="ngModel" [(ngModel)]="searchinitialdate"
                  required />
            
              </div>
              <div class="form-group">
                <label for="bmd-label-floating">End Date:</label>
                <input type="date" class="form-control" name="endDate" #endDate="ngModel" [(ngModel)]="searchenddate" required />
              </div>
            </div>
          </div>


          <div class="container-buttons-right">
            <button class="gts-btn-primary" matRipple (click)="searchAdvanced()" [disabled]="this.advancedsearchtext.length == 0 || loader" >
              <i class="fa fa-circle-o-notch fa-spin fa-1x fa-fw" *ngIf="loader"></i>
              <span class="gts-btn-icon-left" *ngIf="!loader">search</span><span class="gts-btn-text">Search</span>
            </button>
          </div>
          

        </section>

        <div id="container-advanced-search">
          <!-- <form>
            <div class="row">

                <div class="col-md-4">
                  <h4 style="    font-size: 14px;
                        color: green;
                        font-weight: 400;">Date Range</h4>
                  
                  
                  <div>
                    <div class="form-group">
        
        
                      <select name="ecttw" id="daterangeadv" #daterangeadv="ngModel" [(ngModel)]="daterangeadvancedsearch"
                        (change)="changeDateRange()" class="form-control" required>
                        <option value="All">All</option>
                        <option value="1">Select Range</option>
                      </select>
                    </div>
                  </div>


                  <div *ngIf="daterangeadvancedsearch == '1'" style="    display: inline-flex;">
                    <div style="    margin-right: 40px;" class="form-group">
                      <label for="bmd-label-floating">Initial Date:</label>
                      <input type="date" class="form-control" name="initialDate" #initialDate="ngModel"
                        [(ngModel)]="searchinitialdate" required />
        
                    </div>
                    <div class="form-group">
                      <label for="bmd-label-floating">End Date:</label>
                      <input type="date" class="form-control" name="endDate" #endDate="ngModel" [(ngModel)]="searchenddate"
                        required />
                    </div>
                  </div>

                  
                </div>
        
        
            </div>
        
        
            <button [disabled]="this.advancedsearchtext.length == 0" class="btn btn-info" (click)="searchAdvanced()">
              Search
            </button>
          </form> -->
        </div>


        <!-- Loading & Message no found -->
        <section style="margin: 16px 0px;">
          <mat-progress-bar style="width: 100%" *ngIf="loader" mode="indeterminate"></mat-progress-bar>

          <section style="background-color: #FAFAFA; margin-top: 16px" *ngIf="this.showMsgSearchingNotResults == 1" id="showMsgSearchingNotResults">
            <div style="padding: 8px 16px">
              <h3 style="font-family: roboto; font-weight: light; font-size: 18px; text-align: center;"> <mat-icon fontIcon="warning" style="color: #FF9E0F; padding-top: 5px"></mat-icon> No records found, please try again.</h3>
            </div>
          </section>

          <!-- <div *ngIf="this.showMsgSearchingNotResults == 1" id="showMsgSearchingNotResults" class="alert alert-danger"
            role="alert">
            <i style="color: white" class="material-icons"> cancel </i> No records found, please try again
          </div> -->

        </section>
        

        <!-- <section *ngIf="this.showsearchResults == 1" 
          style="background-color: #66c37c; max-width: 100%; max-height: 600px; overflow: auto;">
          <br>

          <table mat-table [dataSource]="dataSource" style="width: 100%;">
            
            <ng-container matColumnDef="fileName">
              <th mat-header-cell *matHeaderCellDef> Name </th>
              <td mat-cell *matCellDef="let element" > {{element.filename}} </td>
            </ng-container>
        
            <ng-container matColumnDef="accions" stickyEnd>
              <th mat-header-cell *matHeaderCellDef aria-label="row actions">Actions</th>
              <td mat-cell *matCellDef="let element">
                <mat-icon>more_vert</mat-icon>
              </td>
            </ng-container>
        
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
        </section>

         -->


        
        
          

        <!-- ******************** ********************************** ************************************* -->




        <!-- Results -->
        <section *ngIf="this.showsearchResults == 1" >
          <p class="itad-card-title-2">Instant Results</p>

        <div style="max-width: 100%; max-height: 300px; overflow-y: auto;">
          <table id="datatablesSearch" class="table table-striped table-hover" cellspacing="0" width="100%" style="width: 100%">
            <thead>
              <tr>
                <th style="max-width: 90%; word-break: break-word; position: sticky; top: 0; background: #fff; z-index:100">{{ dataTableSearch.headerRow[0] }}
                </th>
        
                <th class="text-right" style="width:10% !important; position: sticky; top: 0; background: #fff; z-index:100">
                  {{ dataTableSearch.headerRow[1] }}
                </th>
              </tr>
            </thead>
        
            <tbody>
              <tr *ngFor="let row of dataTableSearch.dataRows" id="file{{ row[0] }}">
                <td style="max-width: 90%; word-break: break-word">{{ row[1] }}</td>
        
                <td style="max-width: 10%">
        
        
                  <div style="display: flex; justify-content: flex-end;">
                     <button class="gts-btn-primary-only-icon" matRipple [matMenuTriggerFor]="fileActionsMenu">
                        <span class="gts-btn-icon">more_vert</span>
                      </button>
                  </div>
        
                  <mat-menu #fileActionsMenu="matMenu">
                    <button mat-menu-item (click)="goFolder(row[2])">Open Folder</button>
                    <button mat-menu-item (click)="openFile(row[0])">View File</button>
                    <button mat-menu-item (click)="downloadFile(row[0])">Download</button>
                  </mat-menu>
        
                </td>
        
        
              </tr>
            </tbody>
        
          </table>
        </div>
          


          


        </section>


        

        <!-- <div
          *ngIf="this.showsearchResults == 1"
          class="material-datatables"
        >
          <table
            id="datatablesSearch"
            class="table table-striped table-no-bordered table-hover"
            cellspacing="0"
            width="100%"
            style="width: 100%"
          >
            <thead>
              <tr>
                <th>{{ dataTableSearch.headerRow[0] }}</th>

                <th class="disabled-sorting text-right">
                  {{ dataTableSearch.headerRow[1] }}
                </th>
              </tr>
            </thead>
            <tfoot>
              <tr>
                <th>{{ dataTableSearch.footerRow[0] }}</th>

                <th class="text-right">
                  {{ dataTableSearch.footerRow[1] }}
                </th>
              </tr>
            </tfoot>
            <tbody>
              <tr
                *ngFor="let row of dataTableSearch.dataRows"
                id="file{{ row[0] }}"

              >
                <td>{{ row[1] }}</td>

                <td class="text-right">
                  <a (click)="goFolder(row[2])"
                    ><button mat-raised-button class="btn btn-info">
                      Open Folder
                    </button></a
                  >
                  <a (click)="openFile(row[0])" target="_blank"
                    ><button mat-raised-button class="btn btn-info">
                      View File
                    </button></a
                  >
                  <button
                    (click)="downloadFile(row[0])"
                    mat-raised-button
                    class="btn btn-success"
                  >
                    Download
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div> -->

      </div>

      <div class="modal-footer">

      </div>

    </div>
  </div>
</div>


<!-- MODAL - modalPOSearch -->
<div class="modal fade" id="modalPOSearch" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false" (wheel)="onScroll($event)"><!-- MODAL - HB MODE OK -->
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">PO Search</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      
      <div class="modal-body">
      


          <div id="container-po-search">
            <form>
              <input type="text" placeholder="Search PO" class="form-control" [(ngModel)]="this.advancedpotext"
                name="advancedpotext" />
      
              <button class="btn btn-info" (click)="searchPO()">
                Search
              </button>
            </form>
          </div>
      
          <div id="showMsgPOSearching" style="display: none" class="alert alert-info" role="alert">
            <i style="color: white" class="material-icons"> sync </i> Please
            wait, searching in progress
          </div>
      
          <div *ngIf="this.showMsgPOSearchingNotResults == 1" id="showMsgPOSearchingNotResults" class="alert alert-danger"
            role="alert">
            <i style="color: white" class="material-icons"> cancel </i> No
            records found, please try again
          </div>
      
          <div *ngIf="this.showsearchPOResults == 1" class="material-datatables">
            <table id="datatablesPOSearch" class="table table-striped table-no-bordered table-hover" cellspacing="0"
              width="100%" style="width: 100%">
              <thead>
                <tr>
                  <th>{{ dataTablePOSearch.headerRow[0] }}</th>
      
                  <th class="disabled-sorting text-right">
                    {{ dataTablePOSearch.headerRow[1] }}
                  </th>
                </tr>
              </thead>
              <tfoot>
                <tr>
                  <th>{{ dataTablePOSearch.footerRow[1] }}</th>
      
                  <th class="text-right">
                    {{ dataTablePOSearch.footerRow[1] }}
                  </th>
                </tr>
              </tfoot>
              <tbody>
                <tr *ngFor="let row of dataTablePOSearch.dataRows" id="file{{ row[0] }}">
                  <td>{{ row[1] }}</td>
      
                  <td class="text-right">
                    <a (click)="goFolder(row[0])"><button mat-raised-button class="btn btn-info">
                        Open Folder
                      </button></a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>


      </div>

      <div class="modal-footer">

      </div>
      
    </div>
  </div>
</div>


<!-- MODAL - modalPermissions -->
<div class="modal fade" id="modalPermissions" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false" (wheel)="onScroll($event)"><!-- MODAL - HB MODE OK -->
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Permissions</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      
      <div class="modal-body">

        <div
        style="
          padding: 15px 0 15px 10px;
          border-radius: 6px;
          border: 1px dashed #ccc;
          background-color: #fafafa;
          color: black;
        "
        *ngIf="
        this.privilegio.level == 'ADMINISTRATOR' ||
        this.privilegio.level == 'MANAGER' ||
        this.privilegio.level == 'worker' ||
        this.privilegio.level == 'PURCHASINGREP'
      "
      >
        <ul style="    list-style-type: none;">
          <!-- <li style="    font-size: medium;"> <span style="font-weight: 600;">Folder Name:</span> {{ this.folderinterno.name }}</li> -->
        </ul>
        <div
          *ngIf="
            this.privilegio.level == 'ADMINISTRATOR' ||
            this.privilegio.level == 'MANAGER' ||
            this.privilegio.level == 'worker' ||
            this.privilegio.level == 'PURCHASINGREP'
          "
        >
          <h4 style="    margin-left: 40px;">Permissions</h4>
          <ul style="list-style: none">
            <li
              id="permi-{{ permission.id }}"
              *ngFor="let permission of permissions"
            >
              <i style="color: green" class="material-icons">person</i>
              {{ permission.user.name }} {{ permission.user.surname }}
              <i
                style="color: red; cursor:pointer"
                (click)="deletePermiso(permission)"
                class="material-icons"
              >
                delete_forever
              </i>
            </li>
          </ul>
          <h3>Add New Permission</h3>
          <div class="row">
            
            <div class="col-sm-6">
              <mat-form-field class="example-full-width">
            <input
              type="text"
              [(ngModel)]="this.folderPermissions.user_id"
              placeholder="Select User"
              aria-label="Select User"
              matInput
              [formControl]="myControlClientes"
              [matAutocomplete]="autoClientes"
              id="nameCliente"
            />
            <mat-autocomplete
              #autoClientes="matAutocomplete"
              [displayWith]="displayFn"
            >
              <mat-option
                *ngFor="let option of filteredClientes | async"
                [value]="option"
              >
                {{ option.name }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
          <button
          [disabled]="!folderPermissions.user_id"
            (click)="selectUserPermission()"
            class="btn btn-success"
          >
            Add user
          </button>
            </div>
            <div class="col-sm-6">
                <mat-form-field class="example-full-width">
                  <input
                    type="text"
                    [(ngModel)]="filepermissionSelected"
                    placeholder="Select Group"
                    aria-label="Select Group"
                    matInput
                    [formControl]="myControlGroups"
                    [matAutocomplete]="autoGroups"
                    id="nameCliente"
                  />
                  <mat-autocomplete
                    #autoGroups="matAutocomplete"
                    [displayWith]="displayFnGroup"
                  >
                    <mat-option
                      *ngFor="let option of filteredGroups | async"
                      [value]="option"
                    >
                      {{ option.name }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
                <button 
                [disabled]="!filepermissionSelected"
                  (click)="selectGroupPermission()"
                  class="btn btn-success"
                >
                  Add user group
                </button>
            </div>
          </div>

          
        </div>
      </div>
        
      </div>

      <div class="modal-footer">

      </div>
      
    </div>
  </div>
</div>


<!-- MODAL - modalFiles -->
<div class="modal fade" id="modalAddFiles" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false" (wheel)="onScroll($event)"><!-- MODAL - HB MODE OK -->
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Files UP</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      
      <div class="modal-body">
        <div style="height: 300px;" *ngIf="
                      this.privilegio.level == 'ADMINISTRATOR' ||
                      this.privilegio.level == 'MANAGER' ||
                      this.privilegio.level == 'worker' ||
                      this.privilegio.level == 'CLERICALREP' ||
                      this.privilegio.level == 'PURCHASINGREP'
                    " class="resp-container">
          <iframe class="resp-iframe" [src]="this.urlUpload" scrolling="no" allow="encrypted-media" allowfullscreen></iframe>
          <!-- <iframe class="resp-iframe" [src]="urlSafe" scrolling="no" allow="encrypted-media" allowfullscreen></iframe> -->

        </div>
      
      </div>

      <div class="modal-footer">

      </div>
      
    </div>
  </div>
</div>

